import { RootState } from '@/store/types/RootState';
import { SortDirection } from '@/enums/SortDirection';

export const selectAddBenefitValue = (state: RootState) => state.benefits.addBenefitValue;

export const selectBenefitTransactionsById = (id: number) => (state: RootState) =>
  state.benefits.transactionDetails.byBenefitId[id]?.listings ?? [];

export const selectBenefitTransactionsDetailsPagination = (id: number | string) => (state: RootState) =>
  state.benefits.transactionDetails.byBenefitId[id]?.pagination ?? {
    pagination: {
      numberOfItems: 0,
      first: '1',
      last: undefined,
      previous: '0',
      next: '0',
      page: 1,
      perPage: 5,
    },
  };

export const selectBenefitTransactionsDetailsSorting = (benefitId: string | number) => (state: RootState) =>
  state.benefits.transactionDetails.byBenefitId[benefitId]?.sorting ?? {
    sortBy: 'createdAt',
    sortDirection: SortDirection.ASC,
  };

export const selectHideCompleteBenefitTransactions = (benefitId: string | number) => (state: RootState) =>
  state.benefits.transactionDetails.byBenefitId[benefitId]?.hideCompleteTransactions ?? false;

export const selectBenefitTransactionsDetailsStatuses = (benefitId: string | number) => (state: RootState) =>
  state.benefits.statuses.benefitTransactionsDetails[benefitId] ?? {
    isLoading: false,
    isFetching: false,
    isError: false,
    isSuccess: false,
  };
